/* kk-promo-deal.js — direct add-to-cart for the main-product `promo_deal` block.
   Same mechanism as the card direct-ATC in snippets/product-card.liquid: KK.cart.add (the only cart
   caller) with cart-drawer + header section re-render, then kk:drawer:open. Delegated on document. */
(function () {
  if (window.__kkPromoDealBound) return;
  window.__kkPromoDealBound = true;
  /* Promo variant display: when the variant picker hid a single-size tile and pre-checked its "2er Set"
     twin (data-promo-autoselect), fire a change so price / variant id / URL follow the visible tile. */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.kk-vp__radio[data-promo-autoselect]:checked').forEach(function (r) {
      r.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
  var FALLBACK = 'Der Artikel konnte nicht hinzugefügt werden. Bitte versuche es erneut.';
  function userMessage(err) {
    if (err && typeof err.userMessage === 'string' && err.userMessage) return err.userMessage;
    if (window.KK && window.KK.i18n && window.KK.i18n.cartAddError) return window.KK.i18n.cartAddError;
    return FALLBACK;
  }
  function setBusy(btn, on) {
    if (on) { btn.__kkPrev = btn.disabled; btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    else { btn.disabled = !!btn.__kkPrev; btn.removeAttribute('aria-busy'); }
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-deal-atc]') : null;
    if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();
    var root = btn.closest('.s-pdp__deal') || document;
    var select = root.querySelector('[data-deal-variant]');
    var region = root.querySelector('[data-deal-error]');
    var variantId = select ? Number(select.value) : 0;
    if (!variantId) return;
    if (!(window.KK && window.KK.cart)) {            // cart API not loaded → fall back to the product page
      var link = root.querySelector('.s-pdp__deal-link, .s-pdp__deal-media');
      if (link && link.href) window.location.href = link.href;
      return;
    }
    if (region) region.textContent = '';
    setBusy(btn, true);
    try {
      var sections = [];
      var drawer = document.querySelector('cart-drawer[data-section-id]');
      if (drawer) sections.push(drawer.getAttribute('data-section-id'));
      sections.push('header');
      window.KK.cart
        .add({ id: variantId, quantity: 1, properties: { _promo: 'deal' } }, { sections: sections.join(',') })
        .then(function () {
          if (window.KK.pubsub) window.KK.pubsub.publish('kk:drawer:open', { id: 'cart' });
        })
        .catch(function (err) {
          if (region) region.textContent = userMessage(err);
          else console.warn('[kk] promo deal add-to-cart failed', err);
        })
        .finally(function () { setBusy(btn, false); });
    } catch (err) {
      setBusy(btn, false);
      if (region) region.textContent = userMessage(err);
      console.warn('[kk] promo deal add-to-cart could not be started', err);
    }
  });
})();
